import { COMMON_MESSAGES, FrameUtils } from '$lib/services/notification.service';
import { writable, type Writable } from 'svelte/store';

export let modalStore: any;

function createModalStore(isModal: boolean) {
	const modal = writable({ isModal, isModalClosed: false });
	return {
		...modal,
		closeModal: (data?: any) => close(modal.update, data?.NumberOfInstallments ? { ...data } : null)
	};
}

function close(update: any, data: any) {
	const whereTo = window?.parent || window?.frameElement;
	if (whereTo) {
		FrameUtils.notify(COMMON_MESSAGES.LEARNMORE_CLOSED, null, { window: whereTo });
	}
	update((s: ModalConfig) => {
		return {
			...s,
			isModalClosed: true
		};
	});
}

export const initStore = (isModal: boolean) => {
	modalStore = createModalStore(isModal);
};

interface ModalConfig {
	isModal: boolean;
	isModalClosed: boolean;
}

const loading: Writable<boolean> = writable<boolean>(true);

export const loadingStore = { ...loading };
